(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/bg", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/bg"] = factory();
	else
		root["i18n/bg"] = factory();
})(window, function() {
return 